import { Global, css } from '@emotion/react';
import PropTypes from 'prop-types';
import React from 'react';

import { InferPropTypes } from '../../types';

/**
 * Fonts is used primarily to declare global font styles in the ThemeProvider
 *
 * */

const GOOGLE_CLOUD_CDN = 'https://fonts.gstatic.com';
const PODIUM_CDN = 'https://assets.podium.com';

const propTypes = {
  url: PropTypes.string
};
const defaultProps = {
  url: PODIUM_CDN
};

type FontProps = InferPropTypes<typeof PropTypes, typeof defaultProps>;
function Fonts({ url }: FontProps): React.ReactElement {
  return (
    <Global
      styles={css`
        @font-face {
          font-family: 'Graphik';
          font-style: normal;
          font-weight: 400;
          src: url(${url}/fonts/Graphik-Regular.woff) format('woff');
        }
        @font-face {
          font-family: 'Graphik';
          font-style: normal;
          font-weight: 500;
          src: url(${url}/fonts/Graphik-Medium.woff) format('woff');
        }
        @font-face {
          font-family: 'Graphik';
          font-style: normal;
          font-weight: 600;
          src: url(${url}/fonts/Graphik-Semibold.woff) format('woff');
        }
        @font-face {
          font-display: swap;
          font-family: 'SourceCodePro-Regular';
          font-style: normal;
          font-weight: 400;
          src: url(${GOOGLE_CLOUD_CDN}/s/sourcecodepro/v14/HI_SiYsKILxRpg3hIP6sJ7fM7PqlPevWnsUnxg.woff2) format('woff2');
          unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074,
            U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
        }

        @font-face {
          font-display: swap;
          font-family: 'SourceCodePro-Medium';
          font-style: normal;
          font-weight: 500;
          src: url(${GOOGLE_CLOUD_CDN}/s/sourcecodepro/v14/HI_XiYsKILxRpg3hIP6sJ7fM7PqtzsjDs-cq7Gq0DA.woff2)
            format('woff2');
          unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074,
            U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
        }

        @font-face {
          font-display: swap;
          font-family: 'SourceCodePro-Semibold';
          font-style: normal;
          font-weight: 600;
          src: url(${GOOGLE_CLOUD_CDN}/s/sourcecodepro/v14/HI_XiYsKILxRpg3hIP6sJ7fM7Pqt4s_Ds-cq7Gq0DA.woff2)
            format('woff2');
          unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074,
            U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
        }

        body {
          -moz-osx-font-smoothing: grayscale;
          -webkit-font-smoothing: antialiased;
          font-smoothing: antialiased;
        }
      `}
    />
  );
}

Fonts.propTypes = propTypes;
Fonts.defaultProps = defaultProps;

export default Fonts;
